var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useContext, useEffect, useState, useRef } from 'react';
import { Box, Flex, Badge, IconButton, Tooltip, Image } from 'pcln-design-system';
import { InformationOutline } from 'pcln-icons';
import { ChatHeader } from 'pcln-design-system';
import { ChatbotDataContext } from './context/ChatbotDataContext';
var TRAVEL_BOT_LOGO = 'https://s1.pclncdn.com/design-assets/pcln-bot/logos/pcln_bot_penny_logo_v1.1.svg';
/**
 * DefaultModalHeader for chat modal
 * @public
 */
export var DefaultModalHeader = function (props) {
    var isLivePersonSessionActive = useContext(ChatbotDataContext).isLivePersonSessionActive;
    var _a = useState(false), isDisplayed = _a[0], setTooltipDisplayState = _a[1];
    var modalHeaderRef = useRef(null);
    useEffect(function () {
        if (props.onDefaultModalHeaderRendered) {
            props.onDefaultModalHeaderRendered();
        }
    }, []);
    useEffect(function () {
        // Todo This should be removed as soon as DS updates the ChatHeader to accept props to add the flexibility to hide or display the minimize Button.
        if (isLivePersonSessionActive) {
            modalHeaderRef.current.querySelectorAll('button')[1].style.display = 'inline-block';
        }
        else {
            modalHeaderRef.current.querySelectorAll('button')[1].style.display = 'none';
        }
    }, [isLivePersonSessionActive]);
    var IconButtonProps = {
        ml: 2,
        id: 'openTooltipButton',
        'data-testid': 'openTooltipButton',
        title: 'open tooltip',
        onClick: function (e) {
            e.preventDefault();
            setTooltipDisplayState(!isDisplayed);
        },
        icon: React.createElement(InformationOutline, { size: 16 }),
    };
    return (React.createElement(Box, { ref: modalHeaderRef },
        React.createElement(ChatHeader, { onClose: isLivePersonSessionActive ? props.handleCloseButton : props.onClose, onMinimize: props.onClose },
            React.createElement(Flex, { alignItems: 'center' },
                React.createElement(Image, { src: TRAVEL_BOT_LOGO, height: '28', width: '68', alt: 'Travel Bot Logo' }),
                React.createElement(Badge, { color: 'primary', bg: 'background.light' }, "BETA"),
                React.createElement(Box, { mr: 'auto' },
                    React.createElement(IconButton, __assign({}, IconButtonProps)),
                    isDisplayed && (React.createElement(Tooltip, { bg: 'background.darkest', color: 'background.lightest', zIndex: 10, left: true }, "Powered by ChatGPT. Chat transcripts are recorded for quality review purposes. Bot may produce inaccurate information. Please do not share any personal information in the chat.")))))));
};
//# sourceMappingURL=DefaultModalHeader.js.map